import {hue} from "./color.js";

export default function(a, b) {
  var i = hue(+a, +b);
  return function(t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/hue.js
// module id = ./node_modules/d3-interpolate/src/hue.js
// module chunks = 1